var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.06061C0 5.64221 0.348223 5.30303 0.777778 5.30303H13.2222C13.6518 5.30303 14 5.64221 14 6.06061V6.81818C14 7.23658 13.6518 7.57576 13.2222 7.57576H0.777778C0.348223 7.57576 0 7.23658 0 6.81818V6.06061Z",
    fill: "#818EA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.84848C0 9.43009 0.348223 9.09091 0.777778 9.09091H13.2222C13.6518 9.09091 14 9.43009 14 9.84848V10.6061C14 11.0245 13.6518 11.3636 13.2222 11.3636H0.777778C0.348223 11.3636 0 11.0245 0 10.6061V9.84848Z",
    fill: "#818EA3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32643 0.378788C6.62579 -0.126263 7.37421 -0.126262 7.67358 0.378788L9.02073 2.65152C9.32009 3.15657 8.94588 3.78788 8.34715 3.78788H5.65285C5.05412 3.78788 4.67991 3.15657 4.97927 2.65152L6.32643 0.378788Z",
    fill: "#818EA3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67357 16.2879C7.37421 16.7929 6.62579 16.7929 6.32642 16.2879L4.97927 14.0152C4.67991 13.5101 5.05412 12.8788 5.65285 12.8788H8.34715C8.94588 12.8788 9.32009 13.5101 9.02073 14.0152L7.67357 16.2879Z",
    fill: "#818EA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.6d150ee39f08f118e04e469c23001ca5.svg";
export { ForwardRef as ReactComponent };